import { AsYouType, parse } from 'libphonenumber-js';

export class PhoneNumber {
  constructor(private v: string) {}

  static fromE164(v: string): PhoneNumber {
    const parsedNumber = parse(v, 'JP');
    return new PhoneNumber('0' + parsedNumber.phone.toString());
  }

  // 電話番号を E.164形式にフォーマットする。https://en.wikipedia.org/wiki/E.164
  toE164(): string {
    const asYourType = new AsYouType('JP');
    asYourType.input(this.v);
    const num = asYourType.getNumber();

    if (num !== undefined) {
      return num.number.toString();
    }

    return '';
  }

  // ハイフン無しの番号を返す.
  getValueWithoutHyphen(): string {
    return this.v.replace(/\-/g, '');
  }

  hasValue(): boolean {
    return this.v !== '';
  }

  eq(other: PhoneNumber): boolean {
    return this.v === other.v;
  }
}
